<div class="switch-container">
  <label class="text" [ngClass]="!isChecked ? 'selected' : ''">{{ labels[0] }}</label>
  <label class="switch">
    <input type="checkbox" [(ngModel)]="isChecked" (change)="toggleSwitch()" />
    <span class="slider round"></span>
  </label>
  <label class="text" [ngClass]="isChecked ? 'selected' : ''">{{ labels[1] }}</label>
</div>
